import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText
} from '@mui/material'
import React from 'react'

import HelpIcon from '@mui/icons-material/Help'
import InfoIcon from '@mui/icons-material/Info'
import WarningIcon from '@mui/icons-material/Warning'

interface ListItemIconProps {
  primary: string | JSX.Element
  secondary: string | JSX.Element
  icon?: 'help' | 'info' | 'warning'
}

export const ListItemIcon: React.FC<ListItemIconProps> = ({
  primary,
  secondary,
  icon
}) => {
  let iconComponent
  switch (icon) {
    case 'help':
      iconComponent = <HelpIcon />
      break
    case 'info':
      iconComponent = <InfoIcon />
      break
    case 'warning':
      iconComponent = <WarningIcon />
      break
    default:
      iconComponent = undefined
      break
  }
  return (
    <ListItem>
      {iconComponent && (
        <ListItemAvatar>
          <Avatar>{iconComponent}</Avatar>
        </ListItemAvatar>
      )}
      <ListItemText primary={primary} secondary={secondary} />
    </ListItem>
  )
}
